import { Modifier } from '@popperjs/core';

// eslint-disable-next-line import/prefer-default-export
export const sameWidth: Modifier<'sameWidth', object> = Object.freeze({
  name: 'sameWidth',
  enabled: true,
  phase: 'beforeWrite',
  fn({ state }) {
    state.styles.popper.width = `${state.rects.reference.width}px`;
  },
  requires: ['computeStyles']
});
